module.exports = __webpack_public_path__ + "img/Desk_shelf(cube70).2f7e2b59.png";